import { Product } from "@/shared/types/product"

const escape = (value: string) => `"${(value ?? "").replace(/"/g, '""')}"`
const CSV_HEADER = ["Name", "Description", "Generated URL"]

/**
 * Export multiple products as a single CSV file download.
 * Each product contributes one row per generated URL, or a single row with an empty URL if none.
 */
const exportProductsToCsv = (products: Product[]): void => {
  const rows = products.flatMap(product => {
    const urls = product.generatedImageUrls?.length ? product.generatedImageUrls : [""]
    return urls.map(url => [escape(product.name ?? ""), escape(product.description ?? ""), escape(url)])
  })
  const csvContent = [CSV_HEADER.join(","), ...rows.map(r => r.join(","))].join("\n")
  const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" })
  const url = URL.createObjectURL(blob)
  const link = document.createElement("a")
  link.href = url
  link.download = `listings_export_${Date.now()}.csv`
  link.click()
  URL.revokeObjectURL(url)
}

export { exportProductsToCsv }
